var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "720px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#4285fa",
    d: "M 222.5,-0.5 C 340.167,-0.5 457.833,-0.5 575.5,-0.5C 577.599,0.611848 579.933,1.27852 582.5,1.5C 583.78,2.93127 585.447,3.59794 587.5,3.5C 591.753,4.62875 595.753,6.29542 599.5,8.5C 599.973,9.90632 600.973,10.573 602.5,10.5C 607.92,13.5549 612.587,17.5549 616.5,22.5C 616.833,23.5 617.5,24.1667 618.5,24.5C 620.207,25.8726 621.54,27.5393 622.5,29.5C 622.427,31.0269 623.094,32.0269 624.5,32.5C 635.322,50.1338 645.655,68.1338 655.5,86.5C 655.427,88.0269 656.094,89.0269 657.5,89.5C 662.193,96.8853 666.526,104.552 670.5,112.5C 670.427,114.027 671.094,115.027 672.5,115.5C 678.655,125.135 684.322,135.135 689.5,145.5C 689.427,147.027 690.094,148.027 691.5,148.5C 695.017,153.534 698.017,158.867 700.5,164.5C 700.427,166.027 701.094,167.027 702.5,167.5C 703.338,167.842 703.672,168.508 703.5,169.5C 703.725,172.546 705.058,174.879 707.5,176.5C 710.669,180.833 713.336,185.5 715.5,190.5C 715.427,192.027 716.094,193.027 717.5,193.5C 722.533,201.569 727.2,209.902 731.5,218.5C 731.427,220.027 732.094,221.027 733.5,221.5C 734.338,221.842 734.672,222.508 734.5,223.5C 734.427,225.027 735.094,226.027 736.5,226.5C 739.499,231.824 742.499,237.158 745.5,242.5C 745.427,244.027 746.094,245.027 747.5,245.5C 751.337,251.17 754.67,257.17 757.5,263.5C 757.427,265.027 758.094,266.027 759.5,266.5C 760.338,266.842 760.672,267.508 760.5,268.5C 760.427,270.027 761.094,271.027 762.5,271.5C 764.362,273.891 765.696,276.558 766.5,279.5C 767.298,281.966 768.631,283.966 770.5,285.5C 772.736,288.967 774.736,292.634 776.5,296.5C 776.427,298.027 777.094,299.027 778.5,299.5C 779.338,299.842 779.672,300.508 779.5,301.5C 779.427,303.027 780.094,304.027 781.5,304.5C 782.674,305.514 783.34,306.847 783.5,308.5C 783.427,310.027 784.094,311.027 785.5,311.5C 785.833,312.167 786.167,312.833 786.5,313.5C 786.427,315.027 787.094,316.027 788.5,316.5C 791.407,321.217 793.741,326.217 795.5,331.5C 795.402,333.553 796.069,335.22 797.5,336.5C 797.875,338.698 798.542,340.698 799.5,342.5C 799.5,352.167 799.5,361.833 799.5,371.5C 798.049,375.368 796.715,379.368 795.5,383.5C 794.094,383.973 793.427,384.973 793.5,386.5C 792.773,388.954 791.773,391.287 790.5,393.5C 789.094,393.973 788.427,394.973 788.5,396.5C 787.262,399.738 785.596,402.738 783.5,405.5C 782.094,405.973 781.427,406.973 781.5,408.5C 778.355,414.597 775.022,420.597 771.5,426.5C 770.094,426.973 769.427,427.973 769.5,429.5C 767.649,432.378 765.982,435.378 764.5,438.5C 763.094,438.973 762.427,439.973 762.5,441.5C 762.025,443.784 761.025,445.784 759.5,447.5C 701.194,388.527 642.527,329.86 583.5,271.5C 583.672,270.508 583.338,269.842 582.5,269.5C 549.5,269.5 516.5,269.5 483.5,269.5C 482.834,275.157 482.501,280.99 482.5,287C 482.504,293.207 483.171,299.04 484.5,304.5C 494.575,315.242 504.908,325.575 515.5,335.5C 515.5,339.167 515.5,342.833 515.5,346.5C 496.035,327.535 476.701,308.368 457.5,289C 456.906,288.536 456.239,288.369 455.5,288.5C 449.54,278.673 440.873,272.507 429.5,270C 413.454,269.079 397.454,269.412 381.5,271C 369.056,275.938 361.056,284.771 357.5,297.5C 356.596,298.209 356.263,299.209 356.5,300.5C 355.67,308.99 355.17,317.657 355,326.5C 341.5,313.667 328.333,300.5 315.5,287C 314.906,286.536 314.239,286.369 313.5,286.5C 307.522,277.506 299.189,272.006 288.5,270C 274.167,269.333 259.833,269.333 245.5,270C 233.077,273.414 223.91,280.914 218,292.5C 217.023,294.74 216.523,297.073 216.5,299.5C 215.833,323.331 215.5,347.331 215.5,371.5C 215.5,395.843 216.167,419.843 217.5,443.5C 307.454,533.618 396.787,623.451 485.5,713C 399.501,713.5 313.501,713.667 227.5,713.5C 216.455,712.915 206.455,709.582 197.5,703.5C 197.027,702.094 196.027,701.427 194.5,701.5C 192.205,700.525 190.205,699.192 188.5,697.5C 188.5,695.5 187.5,694.5 185.5,694.5C 184.167,693.167 182.833,691.833 181.5,690.5C 181.5,688.5 180.5,687.5 178.5,687.5C 177.248,685.999 176.248,684.332 175.5,682.5C 175.446,680.368 174.446,679.035 172.5,678.5C 170.733,676.062 169.399,673.395 168.5,670.5C 168.573,668.973 167.906,667.973 166.5,667.5C 158.011,653.866 150.011,639.866 142.5,625.5C 142.573,623.973 141.906,622.973 140.5,622.5C 138.914,620.33 137.58,617.996 136.5,615.5C 136.715,613.821 136.048,612.821 134.5,612.5C 130.313,606.127 126.647,599.461 123.5,592.5C 123.573,590.973 122.906,589.973 121.5,589.5C 114.159,577.46 107.159,565.127 100.5,552.5C 100.573,550.973 99.9063,549.973 98.5,549.5C 98.1667,548.833 97.8333,548.167 97.5,547.5C 97.573,545.973 96.9063,544.973 95.5,544.5C 91.261,537.695 87.261,530.695 83.5,523.5C 83.7148,521.821 83.0481,520.821 81.5,520.5C 81.5,520.167 81.5,519.833 81.5,519.5C 81.573,517.973 80.9063,516.973 79.5,516.5C 74.4861,507.825 69.4861,499.158 64.5,490.5C 64.7148,488.821 64.0481,487.821 62.5,487.5C 59.9145,483.331 57.5811,478.997 55.5,474.5C 55.573,472.973 54.9063,471.973 53.5,471.5C 49.9781,465.597 46.6447,459.597 43.5,453.5C 43.573,451.973 42.9063,450.973 41.5,450.5C 40.2485,448.999 39.2485,447.332 38.5,445.5C 38.7148,443.821 38.0481,442.821 36.5,442.5C 36.5,442.167 36.5,441.833 36.5,441.5C 36.573,439.973 35.9063,438.973 34.5,438.5C 29.582,430.333 24.9153,422 20.5,413.5C 20.4456,411.368 19.4456,410.035 17.5,409.5C 17.5,409.167 17.5,408.833 17.5,408.5C 17.573,406.973 16.9063,405.973 15.5,405.5C 13.4042,402.738 11.7375,399.738 10.5,396.5C 10.573,394.973 9.90632,393.973 8.5,393.5C 7.22713,391.287 6.22713,388.954 5.5,386.5C 5.57298,384.973 4.90632,383.973 3.5,383.5C 2.28476,379.368 0.95143,375.368 -0.5,371.5C -0.5,361.833 -0.5,352.167 -0.5,342.5C 0.458201,340.698 1.12487,338.698 1.5,336.5C 2.93127,335.22 3.59794,333.553 3.5,331.5C 5.25931,326.217 7.59264,321.217 10.5,316.5C 11.9063,316.027 12.573,315.027 12.5,313.5C 12.8333,312.833 13.1667,312.167 13.5,311.5C 14.9063,311.027 15.573,310.027 15.5,308.5C 15.6596,306.847 16.3263,305.514 17.5,304.5C 18.9063,304.027 19.573,303.027 19.5,301.5C 19.3284,300.508 19.6618,299.842 20.5,299.5C 21.9063,299.027 22.573,298.027 22.5,296.5C 22.3284,295.508 22.6618,294.842 23.5,294.5C 24.9063,294.027 25.573,293.027 25.5,291.5C 26.5082,289.456 27.5082,287.456 28.5,285.5C 30.369,283.966 31.7023,281.966 32.5,279.5C 33.5251,276.637 34.8585,273.971 36.5,271.5C 37.9063,271.027 38.573,270.027 38.5,268.5C 38.8333,267.833 39.1667,267.167 39.5,266.5C 40.9063,266.027 41.573,265.027 41.5,263.5C 42.4097,260.008 44.0764,257.008 46.5,254.5C 47.9063,254.027 48.573,253.027 48.5,251.5C 52.8055,242.866 57.4722,234.532 62.5,226.5C 63.9063,226.027 64.573,225.027 64.5,223.5C 64.3284,222.508 64.6618,221.842 65.5,221.5C 66.9063,221.027 67.573,220.027 67.5,218.5C 70.3439,212.138 73.6772,206.138 77.5,200.5C 78.9063,200.027 79.573,199.027 79.5,197.5C 82.7448,190.004 86.7448,183.004 91.5,176.5C 92.9063,176.027 93.573,175.027 93.5,173.5C 93.9925,171.181 94.9925,169.181 96.5,167.5C 97.9063,167.027 98.573,166.027 98.5,164.5C 100.983,158.867 103.983,153.534 107.5,148.5C 108.906,148.027 109.573,147.027 109.5,145.5C 118.706,128.28 128.373,111.28 138.5,94.5C 139.906,94.0269 140.573,93.0269 140.5,91.5C 140.328,90.5084 140.662,89.8417 141.5,89.5C 142.906,89.0269 143.573,88.0269 143.5,86.5C 151.345,71.4685 159.678,56.8018 168.5,42.5C 169.906,42.0269 170.573,41.0269 170.5,39.5C 171.079,36.6689 172.412,34.3356 174.5,32.5C 175.906,32.0269 176.573,31.0269 176.5,29.5C 181.851,21.8169 188.517,15.4835 196.5,10.5C 198.027,10.573 199.027,9.90632 199.5,8.5C 206.831,4.50334 214.498,1.50334 222.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    fill: "#1a305b",
    d: "M 582.5,1.5 C 584.553,1.40206 586.22,2.06873 587.5,3.5C 585.447,3.59794 583.78,2.93127 582.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.239
    },
    fill: "#1f2f57",
    d: "M 199.5,8.5 C 199.027,9.90632 198.027,10.573 196.5,10.5C 196.973,9.09368 197.973,8.42702 199.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1e2545",
    d: "M 599.5,8.5 C 601.027,8.42702 602.027,9.09368 602.5,10.5C 600.973,10.573 599.973,9.90632 599.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#141b2f",
    d: "M 616.5,22.5 C 617.833,22.5 618.5,23.1667 618.5,24.5C 617.5,24.1667 616.833,23.5 616.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.137
    },
    fill: "#1d3561",
    d: "M 176.5,29.5 C 176.573,31.0269 175.906,32.0269 174.5,32.5C 174.427,30.9731 175.094,29.9731 176.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.129
    },
    fill: "#1a3661",
    d: "M 622.5,29.5 C 623.906,29.9731 624.573,30.9731 624.5,32.5C 623.094,32.0269 622.427,31.0269 622.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.345
    },
    fill: "#22476f",
    d: "M 170.5,39.5 C 170.573,41.0269 169.906,42.0269 168.5,42.5C 168.427,40.9731 169.094,39.9731 170.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.129
    },
    fill: "#1c3565",
    d: "M 143.5,86.5 C 143.573,88.0269 142.906,89.0269 141.5,89.5C 141.427,87.9731 142.094,86.9731 143.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.125
    },
    fill: "#1b3965",
    d: "M 655.5,86.5 C 656.906,86.9731 657.573,87.9731 657.5,89.5C 656.094,89.0269 655.427,88.0269 655.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.098
    },
    fill: "#192a4f",
    d: "M 140.5,91.5 C 140.573,93.0269 139.906,94.0269 138.5,94.5C 138.427,92.9731 139.094,91.9731 140.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.396
    },
    fill: "#234b77",
    d: "M 670.5,112.5 C 671.906,112.973 672.573,113.973 672.5,115.5C 671.094,115.027 670.427,114.027 670.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    fill: "#203a6b",
    d: "M 109.5,145.5 C 109.573,147.027 108.906,148.027 107.5,148.5C 107.427,146.973 108.094,145.973 109.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    fill: "#203c6b",
    d: "M 689.5,145.5 C 690.906,145.973 691.573,146.973 691.5,148.5C 690.094,148.027 689.427,147.027 689.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.106
    },
    fill: "#1b305a",
    d: "M 98.5,164.5 C 98.573,166.027 97.9063,167.027 96.5,167.5C 96.427,165.973 97.0937,164.973 98.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.106
    },
    fill: "#19335a",
    d: "M 700.5,164.5 C 701.906,164.973 702.573,165.973 702.5,167.5C 701.094,167.027 700.427,166.027 700.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#295595",
    d: "M 703.5,169.5 C 705.199,171.566 706.532,173.9 707.5,176.5C 705.058,174.879 703.725,172.546 703.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.482
    },
    fill: "#234176",
    d: "M 93.5,173.5 C 93.573,175.027 92.9063,176.027 91.5,176.5C 91.427,174.973 92.0937,173.973 93.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.349
    },
    fill: "#20436a",
    d: "M 715.5,190.5 C 716.906,190.973 717.573,191.973 717.5,193.5C 716.094,193.027 715.427,192.027 715.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.114
    },
    fill: "#1b385f",
    d: "M 79.5,197.5 C 79.573,199.027 78.9063,200.027 77.5,200.5C 77.427,198.973 78.0937,197.973 79.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#273e75",
    d: "M 67.5,218.5 C 67.573,220.027 66.9063,221.027 65.5,221.5C 65.427,219.973 66.0937,218.973 67.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#244174",
    d: "M 731.5,218.5 C 732.906,218.973 733.573,219.973 733.5,221.5C 732.094,221.027 731.427,220.027 731.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.353
    },
    fill: "#1d335e",
    d: "M 64.5,223.5 C 64.573,225.027 63.9063,226.027 62.5,226.5C 62.427,224.973 63.0937,223.973 64.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.357
    },
    fill: "#1c355f",
    d: "M 734.5,223.5 C 735.906,223.973 736.573,224.973 736.5,226.5C 735.094,226.027 734.427,225.027 734.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.086
    },
    fill: "#182d50",
    d: "M 745.5,242.5 C 746.906,242.973 747.573,243.973 747.5,245.5C 746.094,245.027 745.427,244.027 745.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42
    },
    fill: "#203a69",
    d: "M 48.5,251.5 C 48.573,253.027 47.9063,254.027 46.5,254.5C 46.427,252.973 47.0937,251.973 48.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.118
    },
    fill: "#182a4c",
    d: "M 41.5,263.5 C 41.573,265.027 40.9063,266.027 39.5,266.5C 39.427,264.973 40.0937,263.973 41.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#18294c",
    d: "M 757.5,263.5 C 758.906,263.973 759.573,264.973 759.5,266.5C 758.094,266.027 757.427,265.027 757.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.306
    },
    fill: "#1c3c5d",
    d: "M 760.5,268.5 C 761.906,268.973 762.573,269.973 762.5,271.5C 761.094,271.027 760.427,270.027 760.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.039
    },
    fill: "#131b2d",
    d: "M 38.5,268.5 C 38.573,270.027 37.9063,271.027 36.5,271.5C 36.427,269.973 37.0937,268.973 38.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 313.5,286.5 C 316.256,290.017 317.923,294.017 318.5,298.5C 318.5,346.5 318.5,394.5 318.5,442.5C 307.167,442.5 295.833,442.5 284.5,442.5C 284.5,419.833 284.5,397.167 284.5,374.5C 273.167,374.5 261.833,374.5 250.5,374.5C 249.503,396.994 249.169,419.661 249.5,442.5C 238.5,442.5 227.5,442.5 216.5,442.5C 216.5,394.833 216.5,347.167 216.5,299.5C 216.523,297.073 217.023,294.74 218,292.5C 223.91,280.914 233.077,273.414 245.5,270C 259.833,269.333 274.167,269.333 288.5,270C 299.189,272.006 307.522,277.506 313.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 455.5,288.5 C 457.212,291.261 458.378,294.261 459,297.5C 459.667,313.5 459.667,329.5 459,345.5C 455.341,359.158 446.841,368.325 433.5,373C 419.551,374.409 405.551,374.909 391.5,374.5C 390.503,396.994 390.169,419.661 390.5,442.5C 379.5,442.5 368.5,442.5 357.5,442.5C 357.5,394.167 357.5,345.833 357.5,297.5C 361.056,284.771 369.056,275.938 381.5,271C 397.454,269.412 413.454,269.079 429.5,270C 440.873,272.507 449.54,278.673 455.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 483.5,269.5 C 516.5,269.5 549.5,269.5 582.5,269.5C 582.5,280.833 582.5,292.167 582.5,303.5C 571.654,303.172 560.987,303.506 550.5,304.5C 550.5,339.167 550.5,373.833 550.5,408.5C 560.987,409.494 571.654,409.828 582.5,409.5C 582.5,420.5 582.5,431.5 582.5,442.5C 549.5,442.5 516.5,442.5 483.5,442.5C 483.5,431.167 483.5,419.833 483.5,408.5C 494.167,408.5 504.833,408.5 515.5,408.5C 515.5,387.833 515.5,367.167 515.5,346.5C 515.5,342.833 515.5,339.167 515.5,335.5C 515.5,325.167 515.5,314.833 515.5,304.5C 505.013,303.506 494.346,303.172 483.5,303.5C 483.5,292.167 483.5,280.833 483.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f79de",
    d: "M 583.5,271.5 C 642.527,329.86 701.194,388.527 759.5,447.5C 755.023,455.578 750.357,463.578 745.5,471.5C 744.094,471.973 743.427,472.973 743.5,474.5C 739.085,483 734.418,491.333 729.5,499.5C 728.094,499.973 727.427,500.973 727.5,502.5C 726.231,505.757 724.564,508.757 722.5,511.5C 721.094,511.973 720.427,512.973 720.5,514.5C 720.672,515.492 720.338,516.158 719.5,516.5C 718.094,516.973 717.427,517.973 717.5,519.5C 713.091,527.986 708.424,536.319 703.5,544.5C 702.094,544.973 701.427,545.973 701.5,547.5C 700.231,550.757 698.564,553.757 696.5,556.5C 695.094,556.973 694.427,557.973 694.5,559.5C 691.686,565.795 688.353,571.795 684.5,577.5C 683.094,577.973 682.427,578.973 682.5,580.5C 681.231,583.757 679.564,586.757 677.5,589.5C 676.094,589.973 675.427,590.973 675.5,592.5C 670.338,602.829 664.671,612.829 658.5,622.5C 657.094,622.973 656.427,623.973 656.5,625.5C 645.362,647.058 633.196,668.058 620,688.5C 607.092,703.037 590.925,711.537 571.5,714C 456.666,714.833 341.999,714.666 227.5,713.5C 313.501,713.667 399.501,713.5 485.5,713C 396.787,623.451 307.454,533.618 217.5,443.5C 228.5,443.5 239.5,443.5 250.5,443.5C 250.5,420.5 250.5,397.5 250.5,374.5C 261.833,374.5 273.167,374.5 284.5,374.5C 284.5,397.167 284.5,419.833 284.5,442.5C 295.988,443.495 307.655,443.828 319.5,443.5C 319.832,394.997 319.499,346.664 318.5,298.5C 317.923,294.017 316.256,290.017 313.5,286.5C 314.239,286.369 314.906,286.536 315.5,287C 328.333,300.5 341.5,313.667 355,326.5C 355.17,317.657 355.67,308.99 356.5,300.5C 356.5,348.167 356.5,395.833 356.5,443.5C 368.167,443.5 379.833,443.5 391.5,443.5C 391.5,420.5 391.5,397.5 391.5,374.5C 405.551,374.909 419.551,374.409 433.5,373C 446.841,368.325 455.341,359.158 459,345.5C 459.667,329.5 459.667,313.5 459,297.5C 458.378,294.261 457.212,291.261 455.5,288.5C 456.239,288.369 456.906,288.536 457.5,289C 476.701,308.368 496.035,327.535 515.5,346.5C 515.5,367.167 515.5,387.833 515.5,408.5C 504.833,408.5 494.167,408.5 483.5,408.5C 482.505,419.988 482.172,431.655 482.5,443.5C 516.167,443.5 549.833,443.5 583.5,443.5C 583.5,431.833 583.5,420.167 583.5,408.5C 572.5,408.5 561.5,408.5 550.5,408.5C 550.5,373.833 550.5,339.167 550.5,304.5C 561.5,304.5 572.5,304.5 583.5,304.5C 583.5,293.5 583.5,282.5 583.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.243
    },
    fill: "#25457c",
    d: "M 32.5,279.5 C 31.7023,281.966 30.369,283.966 28.5,285.5C 28.9287,282.853 30.2621,280.853 32.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.247
    },
    fill: "#24437c",
    d: "M 766.5,279.5 C 768.738,280.853 770.071,282.853 770.5,285.5C 768.631,283.966 767.298,281.966 766.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#224d7a",
    d: "M 25.5,291.5 C 25.573,293.027 24.9063,294.027 23.5,294.5C 23.427,292.973 24.0937,291.973 25.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.365
    },
    fill: "#243867",
    d: "M 22.5,296.5 C 22.573,298.027 21.9063,299.027 20.5,299.5C 20.427,297.973 21.0937,296.973 22.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.365
    },
    fill: "#213a67",
    d: "M 776.5,296.5 C 777.906,296.973 778.573,297.973 778.5,299.5C 777.094,299.027 776.427,298.027 776.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.298
    },
    fill: "#1a2c51",
    d: "M 19.5,301.5 C 19.573,303.027 18.9063,304.027 17.5,304.5C 17.427,302.973 18.0937,301.973 19.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.298
    },
    fill: "#192e51",
    d: "M 779.5,301.5 C 780.906,301.973 781.573,302.973 781.5,304.5C 780.094,304.027 779.427,303.027 779.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aec6f1",
    d: "M 318.5,298.5 C 319.499,346.664 319.832,394.997 319.5,443.5C 307.655,443.828 295.988,443.495 284.5,442.5C 295.833,442.5 307.167,442.5 318.5,442.5C 318.5,394.5 318.5,346.5 318.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ebdf4",
    d: "M 483.5,269.5 C 483.5,280.833 483.5,292.167 483.5,303.5C 494.346,303.172 505.013,303.506 515.5,304.5C 505.167,304.5 494.833,304.5 484.5,304.5C 483.171,299.04 482.504,293.207 482.5,287C 482.501,280.99 482.834,275.157 483.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5c0f0",
    d: "M 582.5,269.5 C 583.338,269.842 583.672,270.508 583.5,271.5C 583.5,282.5 583.5,293.5 583.5,304.5C 572.5,304.5 561.5,304.5 550.5,304.5C 560.987,303.506 571.654,303.172 582.5,303.5C 582.5,292.167 582.5,280.833 582.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0d2f4",
    d: "M 284.5,304.5 C 273.167,304.5 261.833,304.5 250.5,304.5C 250.5,316.167 250.5,327.833 250.5,339.5C 249.505,327.678 249.172,315.678 249.5,303.5C 261.345,303.172 273.012,303.505 284.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407adf",
    d: "M 284.5,304.5 C 284.5,316.167 284.5,327.833 284.5,339.5C 273.167,339.5 261.833,339.5 250.5,339.5C 250.5,327.833 250.5,316.167 250.5,304.5C 261.833,304.5 273.167,304.5 284.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93b3ed",
    d: "M 390.5,303.5 C 402.167,303.5 413.833,303.5 425.5,303.5C 425.5,315.833 425.5,328.167 425.5,340.5C 413.833,340.5 402.167,340.5 390.5,340.5C 390.5,328.167 390.5,315.833 390.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407adf",
    d: "M 391.5,304.5 C 402.5,304.5 413.5,304.5 424.5,304.5C 424.5,316.167 424.5,327.833 424.5,339.5C 413.5,339.5 402.5,339.5 391.5,339.5C 391.5,327.833 391.5,316.167 391.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407adf",
    d: "M 484.5,304.5 C 494.833,304.5 505.167,304.5 515.5,304.5C 515.5,314.833 515.5,325.167 515.5,335.5C 504.908,325.575 494.575,315.242 484.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.09
    },
    fill: "#18284a",
    d: "M 15.5,308.5 C 15.573,310.027 14.9063,311.027 13.5,311.5C 13.427,309.973 14.0937,308.973 15.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.094
    },
    fill: "#17284a",
    d: "M 783.5,308.5 C 784.906,308.973 785.573,309.973 785.5,311.5C 784.094,311.027 783.427,310.027 783.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#131a2c",
    d: "M 12.5,313.5 C 12.573,315.027 11.9063,316.027 10.5,316.5C 10.427,314.973 11.0937,313.973 12.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#131a2b",
    d: "M 786.5,313.5 C 787.906,313.973 788.573,314.973 788.5,316.5C 787.094,316.027 786.427,315.027 786.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8d8f6",
    d: "M 357.5,297.5 C 357.5,345.833 357.5,394.167 357.5,442.5C 368.5,442.5 379.5,442.5 390.5,442.5C 390.169,419.661 390.503,396.994 391.5,374.5C 391.5,397.5 391.5,420.5 391.5,443.5C 379.833,443.5 368.167,443.5 356.5,443.5C 356.5,395.833 356.5,348.167 356.5,300.5C 356.263,299.209 356.596,298.209 357.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.039
    },
    fill: "#152745",
    d: "M 3.5,331.5 C 3.59794,333.553 2.93127,335.22 1.5,336.5C 1.40206,334.447 2.06873,332.78 3.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.035
    },
    fill: "#152845",
    d: "M 795.5,331.5 C 796.931,332.78 797.598,334.447 797.5,336.5C 796.069,335.22 795.402,333.553 795.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2d5f9",
    d: "M 216.5,299.5 C 216.5,347.167 216.5,394.833 216.5,442.5C 227.5,442.5 238.5,442.5 249.5,442.5C 249.169,419.661 249.503,396.994 250.5,374.5C 250.5,397.5 250.5,420.5 250.5,443.5C 239.5,443.5 228.5,443.5 217.5,443.5C 216.167,419.843 215.5,395.843 215.5,371.5C 215.5,347.331 215.833,323.331 216.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.059
    },
    fill: "#162440",
    d: "M 3.5,383.5 C 4.90632,383.973 5.57298,384.973 5.5,386.5C 4.09368,386.027 3.42702,385.027 3.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.063
    },
    fill: "#162440",
    d: "M 795.5,383.5 C 795.573,385.027 794.906,386.027 793.5,386.5C 793.427,384.973 794.094,383.973 795.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#172241",
    d: "M 8.5,393.5 C 9.90632,393.973 10.573,394.973 10.5,396.5C 9.09368,396.027 8.42702,395.027 8.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#152241",
    d: "M 790.5,393.5 C 790.573,395.027 789.906,396.027 788.5,396.5C 788.427,394.973 789.094,393.973 790.5,393.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#172342",
    d: "M 15.5,405.5 C 16.9063,405.973 17.573,406.973 17.5,408.5C 16.0937,408.027 15.427,407.027 15.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#152541",
    d: "M 783.5,405.5 C 783.573,407.027 782.906,408.027 781.5,408.5C 781.427,406.973 782.094,405.973 783.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#234d78",
    d: "M 17.5,409.5 C 19.4456,410.035 20.4456,411.368 20.5,413.5C 19.0256,412.564 18.0256,411.23 17.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#20274a",
    d: "M 771.5,426.5 C 771.573,428.027 770.906,429.027 769.5,429.5C 769.427,427.973 770.094,426.973 771.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#142442",
    d: "M 34.5,438.5 C 35.9063,438.973 36.573,439.973 36.5,441.5C 35.0937,441.027 34.427,440.027 34.5,438.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#152442",
    d: "M 764.5,438.5 C 764.573,440.027 763.906,441.027 762.5,441.5C 762.427,439.973 763.094,438.973 764.5,438.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#213660",
    d: "M 36.5,442.5 C 38.0481,442.821 38.7148,443.821 38.5,445.5C 37.5987,444.71 36.9321,443.71 36.5,442.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6ccf2",
    d: "M 483.5,408.5 C 483.5,419.833 483.5,431.167 483.5,442.5C 516.5,442.5 549.5,442.5 582.5,442.5C 582.5,431.5 582.5,420.5 582.5,409.5C 571.654,409.828 560.987,409.494 550.5,408.5C 561.5,408.5 572.5,408.5 583.5,408.5C 583.5,420.167 583.5,431.833 583.5,443.5C 549.833,443.5 516.167,443.5 482.5,443.5C 482.172,431.655 482.505,419.988 483.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.043
    },
    fill: "#152542",
    d: "M 41.5,450.5 C 42.9063,450.973 43.573,451.973 43.5,453.5C 42.0937,453.027 41.427,452.027 41.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#1a284c",
    d: "M 53.5,471.5 C 54.9063,471.973 55.573,472.973 55.5,474.5C 54.0937,474.027 53.427,473.027 53.5,471.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#172546",
    d: "M 745.5,471.5 C 745.573,473.027 744.906,474.027 743.5,474.5C 743.427,472.973 744.094,471.973 745.5,471.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.506
    },
    fill: "#245581",
    d: "M 62.5,487.5 C 64.0481,487.821 64.7148,488.821 64.5,490.5C 63.5987,489.71 62.9321,488.71 62.5,487.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#161f3d",
    d: "M 729.5,499.5 C 729.573,501.027 728.906,502.027 727.5,502.5C 727.427,500.973 728.094,499.973 729.5,499.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.039
    },
    fill: "#15283f",
    d: "M 722.5,511.5 C 722.573,513.027 721.906,514.027 720.5,514.5C 720.427,512.973 721.094,511.973 722.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#172a4e",
    d: "M 79.5,516.5 C 80.9063,516.973 81.573,517.973 81.5,519.5C 80.0937,519.027 79.427,518.027 79.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.043
    },
    fill: "#172748",
    d: "M 719.5,516.5 C 719.573,518.027 718.906,519.027 717.5,519.5C 717.427,517.973 718.094,516.973 719.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.494
    },
    fill: "#233a6a",
    d: "M 81.5,520.5 C 83.0481,520.821 83.7148,521.821 83.5,523.5C 82.5987,522.71 81.9321,521.71 81.5,520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#152540",
    d: "M 95.5,544.5 C 96.9063,544.973 97.573,545.973 97.5,547.5C 96.0937,547.027 95.427,546.027 95.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#15223d",
    d: "M 703.5,544.5 C 703.573,546.027 702.906,547.027 701.5,547.5C 701.427,545.973 702.094,544.973 703.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#1d2e58",
    d: "M 98.5,549.5 C 99.9063,549.973 100.573,550.973 100.5,552.5C 99.0937,552.027 98.427,551.027 98.5,549.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.063
    },
    fill: "#15243f",
    d: "M 696.5,556.5 C 696.573,558.027 695.906,559.027 694.5,559.5C 694.427,557.973 695.094,556.973 696.5,556.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#182447",
    d: "M 684.5,577.5 C 684.573,579.027 683.906,580.027 682.5,580.5C 682.427,578.973 683.094,577.973 684.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#172542",
    d: "M 121.5,589.5 C 122.906,589.973 123.573,590.973 123.5,592.5C 122.094,592.027 121.427,591.027 121.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.055
    },
    fill: "#182e4a",
    d: "M 677.5,589.5 C 677.573,591.027 676.906,592.027 675.5,592.5C 675.427,590.973 676.094,589.973 677.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51
    },
    fill: "#213661",
    d: "M 134.5,612.5 C 136.048,612.821 136.715,613.821 136.5,615.5C 135.599,614.71 134.932,613.71 134.5,612.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#172a4c",
    d: "M 140.5,622.5 C 141.906,622.973 142.573,623.973 142.5,625.5C 141.094,625.027 140.427,624.027 140.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.047
    },
    fill: "#172747",
    d: "M 658.5,622.5 C 658.573,624.027 657.906,625.027 656.5,625.5C 656.427,623.973 657.094,622.973 658.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.047
    },
    fill: "#182b4e",
    d: "M 166.5,667.5 C 167.906,667.973 168.573,668.973 168.5,670.5C 167.094,670.027 166.427,669.027 166.5,667.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.475
    },
    fill: "#244072",
    d: "M 172.5,678.5 C 174.446,679.035 175.446,680.368 175.5,682.5C 174.026,681.564 173.026,680.23 172.5,678.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.192
    },
    fill: "#1e2f54",
    d: "M 178.5,687.5 C 180.5,687.5 181.5,688.5 181.5,690.5C 180.167,689.833 179.167,688.833 178.5,687.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.365
    },
    fill: "#1e2f54",
    d: "M 185.5,694.5 C 187.5,694.5 188.5,695.5 188.5,697.5C 187.167,696.833 186.167,695.833 185.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.373
    },
    fill: "#1f3a6a",
    d: "M 194.5,701.5 C 196.027,701.427 197.027,702.094 197.5,703.5C 195.973,703.573 194.973,702.906 194.5,701.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.c4156c5de37532ca5cea2e900bb4074f.svg";
export { ForwardRef as ReactComponent };